import { cn } from 'root/src/client/v2/common/helpers/cn';
const BARS = Array.from({ length: 12 }, (_, index) => index);
// The same loading spinner Sonner uses in its loading toasts: 12 radial bars fading from full to
// 15% opacity, staggered. Replicated here (matching Sonner's geometry) so in-app loaders match the
// toasts. Color follows the current text color (`bg-current`); set `text-*` on the wrapper.
export const Spinner = ({ size = 16, className }) => (<span className={cn('relative inline-block shrink-0', className)} style={{ width: size, height: size }} role="status" aria-label="Loading">
		<span className="absolute" style={{ top: '50%', left: '50%', width: size, height: size }}>
			{BARS.map(index => (<span key={index} className="absolute animate-sonner-spin bg-current" style={{
            borderRadius: 6,
            height: '8%',
            width: '24%',
            left: '-10%',
            top: '-3.9%',
            transform: `rotate(${index * 30}deg) translate(146%)`,
            animationDelay: `${-1.2 + index * 0.1}s`,
        }}/>))}
		</span>
	</span>);
